import { createContext, useContext, useMemo, useState } from "react";
import { DEFAULT_ANALYSIS_VERSION } from "../variables/analysisVersions";

const AnalysisVersionValueContext = createContext();
const AnalysisVersionActionsContext = createContext();

export function AnalysisVersionContextProvider({ children }) {
    const [analysisVersion, setAnalysisVersion] = useState(DEFAULT_ANALYSIS_VERSION);

    const analysisVersionActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setAnalysisVersion(newValues);
                },
                setValue: setAnalysisVersion
            }
        },
        []
    )

    return (
        <>
            <AnalysisVersionActionsContext.Provider value={{ analysisVersion: analysisVersionActions }}>
                <AnalysisVersionValueContext.Provider value={{ analysisVersion }}>
                    {children}
                </AnalysisVersionValueContext.Provider>
            </AnalysisVersionActionsContext.Provider>
        </>
    );
}

export function useAnalysisVersionValueContextHook(props) {
    const value = useContext(AnalysisVersionValueContext);

    if (value === undefined) {
        throw new Error('useAnalysisVersionValueContextHook should be used within AnalysisVersionContextProvider');
    }

    return {
        analysisVersion: value.analysisVersion,
    };
}

export function useAnalysisVersionActionsContextHook(props) {
    const value = useContext(AnalysisVersionActionsContext);

    if (value === undefined) {
        throw new Error('useAnalysisVersionActionsContextHook should be used within AnalysisVersionContextProvider');
    }

    return {
        analysisVersion: {
            onSet: value.analysisVersion.onSet,
            setValue: value.analysisVersion.setValue
        },
    };
}
